import React, { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';
import TopBar from 'src/components/TopBar/TopBar';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
    },
    wrapper: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingTop: '4rem',
    },
    contentContainer: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
    },
    content: {
        flex: '1 1 auto',
        height: '100%',
        overflow: 'auto',
        backgroundColor: "#F9FAFF"
    }
}));

function DashboardLayout({ children }: { children: ReactNode }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <TopBar />
            <div className={classes.wrapper}>
                <div className={classes.contentContainer}>
                    <div className={classes.content}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardLayout;
